"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SecuredGradientMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__secured-gradient-multitone-filled__clip0_13938_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5F1DE",
    d: "M2.228 2.517a.892.892 0 00-.819.9v4.788s-.163 5.074 6.548 7.365l.081.041.082-.04c6.711-2.251 6.548-7.366 6.548-7.366V3.417c0-.45-.328-.86-.819-.941-2.7-.328-4.46-1.392-5.36-1.965a.963.963 0 00-.942 0c-.859.573-2.619 1.678-5.32 2.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__secured-gradient-multitone-filled__paint0_linear_13938_12)",
    d: "M8.038 16.02l-.204-.04C.918 13.605 1 8.245 1 8.204V3.417c0-.696.491-1.269 1.146-1.35C4.765 1.738 6.442.716 7.302.183c.45-.245.982-.245 1.391 0 .9.532 2.578 1.555 5.197 1.883.655.081 1.146.654 1.146 1.35v4.788c0 .04.082 5.401-6.834 7.734l-.164.081zM2.268 2.926c-.245 0-.45.245-.45.49v4.789c0 .204-.04 4.787 6.22 6.956 6.261-2.128 6.22-6.752 6.22-6.915V3.458a.566.566 0 00-.45-.532C11.026 2.558 9.184 1.453 8.325.92a.43.43 0 00-.532 0c-.9.532-2.742 1.637-5.524 2.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__secured-gradient-multitone-filled__paint1_linear_13938_12)",
    d: "M6.852 10.783L4.56 8.205c-.164-.164-.123-.41.04-.573.165-.164.41-.123.574.04l1.718 1.965 4.052-3.806a.396.396 0 01.572 0 .396.396 0 010 .573l-4.664 4.379z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__secured-gradient-multitone-filled__paint0_linear_13938_12",
    x1: 1,
    x2: 15.073,
    y1: 8.025,
    y2: 8.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#41AC44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__secured-gradient-multitone-filled__paint1_linear_13938_12",
    x1: 4.45,
    x2: 11.623,
    y1: 8.264,
    y2: 8.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#41AC44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009749"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__secured-gradient-multitone-filled__clip0_13938_12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SecuredGradientMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SecuredGradientMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SecuredGradientMultitoneFilled;
exports["default"] = _default;